import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import YouTubeTranscriptPage from './YouTubeTranscriptPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <YouTubeTranscriptPage />
  </React.StrictMode>
);